import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface OperatorInformationReduxSliceState {
    id?: number;
    firstName?: string;
    lastName?: string;
    imageProfileBaseUrl?: string;
    dummy?: boolean;
}


type SetOperatorInformationPayload = Partial<OperatorInformationReduxSliceState>;


const initialState: OperatorInformationReduxSliceState = {}

const sliceName = 'operatorInformation';

/**
 * The Redux state, action creators, types and reducers of the Operator-information slice.
 */
export const OperatorInformationReduxSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setOperatorInformation: (
            state,
            action: PayloadAction<SetOperatorInformationPayload>) => {
            Object
                .keys(action.payload)
                .forEach((key) => {
                    state[key as keyof SetOperatorInformationPayload] = action.payload[key as keyof SetOperatorInformationPayload] as any;
                });
            return state;
        },
        clearOperatorInformation: () => initialState,
        forceUpdate: (state,) => ({
            ...state,
            dummy: !state.dummy,
        }),
    }
});

export default OperatorInformationReduxSlice;
